import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const fetchMetricsData = createApi(`DashboardMetricsCD`, 'GET');

const DashboardMetricsCD = createSlice({
  name: 'DashboardMetricsCD',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMetricsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMetricsData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchMetricsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default DashboardMetricsCD.reducer;